export default{
    'diet-plans': 'Diet plans',
    foods: 'Foods',
    athletes: 'Clients',
    notifications: 'Notifications',
    calendar: 'Calendar',
    meals: 'Meal templates',
    statistics: 'Statistics',
    notes: 'Note templates',
    recipes: 'Recipes',
    company: 'Company details',
    'change-password': 'Change password',
    'todo-list': 'To-do list',
    tags: 'Tags',
    subscription: 'Subscription & Renewal',
    'print-templates': 'Print templates',
    questionnaires: 'Questionnaires',
    user: 'Account',
    'pay-transaction': 'Pay transaction',
    faq: 'Frequently Asked Questions',
    terms: 'Terms & Conditions',
    admin: 'Admin',
    users: 'User List',
    transactions: 'Transactions',
    reports: 'User reports',
    add: 'Create new client',
    temp: 'Draft',
    coupons: 'Coupon codes / Partners',
    training: 'Training',
    sms: 'SMS settings',
    passcode: 'Data Protection',
    'passcode-removal': 'Passcode Removal',
    'marketplace-profiles': 'vresdiatrofologo',
    educational: 'Athlisis Educational'
}
